// src/components/gis/popupBuilder.js
import { humanizeFieldName } from "./fieldLabels";

const DEFAULT_HIDDEN_FIELDS = [
  "geom", "geometry", "id", "fid", "gid", "__gid", "uid", "scuid", "cuid",
  "path", "featureId", "layerName", "classKey",
];

function isPhotoField(key, value) {
  if (typeof value !== "string" || !value) return false;
  const looksLikeUrlField = /url|photo|image|picture/i.test(key);
  const looksLikeUrlValue = /^https?:\/\//i.test(value) || /\.(jpe?g|png|gif|webp)(\?.*)?$/i.test(value);
  return looksLikeUrlField && looksLikeUrlValue;
}

function resolvePhotoUrl(value) {
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/api")) return value;
  return `/api${value.startsWith("/") ? "" : "/"}${value}`;
}

export function buildPopupHTML(properties, { hiddenFields = [], title = "", subtitle = "" } = {}) {
  const allHidden = [...DEFAULT_HIDDEN_FIELDS, ...hiddenFields];
  const entries = Object.entries(properties).filter(
    ([key, value]) => !allHidden.includes(key) && value !== null && value !== undefined && value !== ""
  );

  const photoEntries = entries.filter(([key, value]) => isPhotoField(key, value));
  const textEntries = entries.filter(([key, value]) => !isPhotoField(key, value));

  const headerHTML = title
    ? `<div class="popup-header">
        <div class="popup-title">${title}</div>
        ${subtitle ? `<div class="popup-subtitle">${subtitle}</div>` : ""}
      </div>`
    : "";

  const tableRows = textEntries
    .map(([key, value]) => {
      const label = humanizeFieldName(key);
      const displayValue = typeof value === "object" ? JSON.stringify(value) : value;
      return `<tr><td class="popup-key">${label}</td><td class="popup-value">${displayValue}</td></tr>`;
    })
    .join("");

  // Note: no <a href>/target="_blank" here anymore — these are clickable
  // divs picked up by a document-level listener (see MeterUpdation.jsx)
  // that opens an in-page lightbox instead of navigating away immediately.
  const photoGallery = photoEntries.length
    ? `<div class="popup-photos">
        ${photoEntries
          .map(([key, value]) => {
            const resolvedUrl = resolvePhotoUrl(value);
            const label = humanizeFieldName(key);
            return `
              <div
                class="popup-photo-item"
                data-photo-src="${resolvedUrl}"
                data-photo-label="${label}"
                role="button"
                tabindex="0"
              >
                <img src="${resolvedUrl}" alt="${label}" loading="lazy" />
                <span>${label}</span>
              </div>`;
          })
          .join("")}
      </div>`
    : "";

  return `
    ${headerHTML}
    <div class="popup-content-wrapper">
      <table class="popup-table">${tableRows}</table>
      ${photoGallery}
      <button class="popup-zoom" id="zoomToFeatureBtn">Zoom to Feature</button>
    </div>
  `;
}